import React, { useEffect, useState } from 'react';
import { Breadcrumb, Button, message, Spin } from 'antd';
import {
  HomeIcon,
  DocumentChartBarIcon,
  CloudArrowDownIcon,
} from "@heroicons/react/16/solid";
import WorkSheetTable from './workSheetTable';
import moment from 'moment';
import { getRequest, postRequest } from '../../utils/APICall';
import DatePickerComponent from '../DatePicker';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import WorkSheetModal from './workSheetModal';

const Worksheet = () => {
  const [selectedDate, setSelectedDate] = useState("");
  const [worksheetData, setWorksheetData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const items = [
    {
      href: '/',
      title: (
        <span className='flex sm:gap-2 items-center'>
          <HomeIcon className="h-6 w-6 text-gray-500" />
          <span className='text-gray-400 sm:text-lg'>Home</span>
        </span>
      ),
    },
    {
      href: '/worksheet',
      title: (
        <span className='flex sm:gap-2 items-center'>
          <DocumentChartBarIcon className="h-6 w-6 text-gray-300" />
          <span className='text-gray-400 sm:text-lg'> Daily WorkSheet</span>
        </span>
      ),
    },
  ];

  const pickFromDate = (date, dateString) => {
    setSelectedDate(dateString);
  };

  useEffect(() => {
    yesterdayWorksheet();
  }, []);

  const handleSearch = async () => {
    if (!selectedDate) return;
    const formattedDate = moment(selectedDate).format("DD-MM-YYYY");
    try {
      setLoading(true);
      const response = await getRequest(`getWorksheet?vworkdate=${formattedDate}`);
      // console.log(response)
      setWorksheetData(response?.data || []);
    } finally {
      setLoading(false);
    }
  };

  const yesterdayWorksheet = async () => {
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    let formatDate = moment(yesterday, "MM/DD/YYYY").format("DD-MMMM-YYYY");
    try {
      setLoading(true);
      const response = await getRequest(`getWorksheet?vworkdate=${formatDate}`);
      // console.log(response)
      setWorksheetData(response.data || []);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text("Daily Worksheet", 14, 22);


    const tableData = worksheetData?.map((item, index) => [
      index + 1,
      moment(item.WORK_DATE).format("DD MMMM YYYY") || "",
      item.FIRSTNAME || "",
      item.WORK_DETAIL || ""
    ]);

    autoTable(doc, {
      head: [["#", "Work Date", "Employee Name", "Work Detail"]],
      body: tableData,
      startY: 40,
      styles: {
        fontSize: 10,
        cellWidth: 'wrap',
        overflow: 'linebreak',
      },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 30 },
        2: { cellWidth: 30 },
        3: { cellWidth: 120 },
      },
    });

    const fileName = selectedDate
      ? `worksheet_${moment(selectedDate).format("DD-MM-YYYY")}.pdf`
      : 'worksheet.pdf';

    doc.save(fileName);
  };

  const handleFullMonthFetch = async ({vtodate,vfromdate,vemployeeid}) => {
   

    try {
      const res = await postRequest("employeeWorksheet", {
        vemployeeid,
        vfromdate,
        vtodate,
      });
      // console.log("resposne",res)
      if (res.success) {
        message.success("Data fetched successfully!");
        setWorksheetData(res?.data)
      } else {
        message.error(res.message || "Failed to fetch data.");
      }
    } catch (err) {
      message.error("Error fetching worksheet data");
    } finally {
  
    }
  };
  // console.log("worksheetData",worksheetData)
  return (
    <div>
      <span className='flex py-4 px-2 sm:p-10 flex-wrap gap-4 justify-between items-center '>
        <span className='flex flex-col gap-2 text-xl  md:text-4xl font-black  '>
          Daily WorkSheet
          <Breadcrumb items={items} />
        </span>
      </span>

      <span className='flex md:justify-start flex-wrap gap-4 items-center px-4 py-4'>
        <span>
          <DatePickerComponent
            onChange={pickFromDate}
            date={selectedDate}
            customStyle="w-[250px] sm:w-[300px] md:w-[352px] h-10"
            placeholder="Select Date ..."
            style={{ width: 300 }}
            size="large"
          />
        </span>

        <span>
          <Button
            color="primary"
            size="large"
            className='sm:ml-4 text-lg font-bold text-gray-100 p-4 px-12 '
            variant="solid"
            onClick={handleSearch}
          >
            Search
          </Button>
        </span>

        <span>
          <Button
            color="primary"
            variant='outlined'
            type="default"
            className="text-lg font-bold text-gray-800  p-5 px-10"
            onClick={() => setIsModalOpen(true)}
          >
            Employee Worksheet
          </Button>
        </span>

        <span>
          <CloudArrowDownIcon
            className="h-12 w-12 md:mr-10 dark:text-gray-400 text-gray-800 hover:cursor-pointer"
            onClick={handleDownloadPDF}
          />
        </span>
      </span>

      <div className="">
        {loading ? (
          <div className="flex justify-center items-center h-60">
            <Spin size="large" tip="Loading worksheet..." />
          </div>
        ) : (
          <WorkSheetTable data={worksheetData} />
        )}
      </div>

      <WorkSheetModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleFullMonthFetch}
      />
    </div>
  );
};

export default Worksheet;
